import {Component} from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import {Form} from 'semantic-ui-react';
import EditableTitle from './EditableTitle';

export default class OptionalTitle extends Component {
  static propTypes = {
    className: PropTypes.string,
    onUpdateData: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
    label: PropTypes.string,
    title: PropTypes.string,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    titleProps: PropTypes.object,
  };

  static defaultProps = {
    isEnabled: true,
    maxLength: 60,
    titleProps: {},
  };

  toggleIsEnabled = () => {
    const {onUpdateData, isEnabled} = this.props;
    onUpdateData({isEnabled: !isEnabled});
  };

  render() {
    const {className, onUpdateData, isEnabled, label, maxLength, placeholder, title, titleProps} = this.props;

    return (
        <Box mb={1}>
          <Form.Group inline className={className}>
            <Form.Checkbox checked={isEnabled} inline label={label} onChange={this.toggleIsEnabled}/>
            <EditableTitle
                title={title}
                placeholder={placeholder}
                maxLength={maxLength}
                isEnabled={isEnabled}
                onUpdateData={onUpdateData}
                {...titleProps}
            />
          </Form.Group>
        </Box>
    );
  }
}
